import React, { Component } from 'react';
import $ from 'jquery';

function scroll(e) {
  e.preventDefault();
  e.stopPropagation();
  const target = $(this)[0].attributes.href.nodeValue;
  $('html, body').animate(
    {
      scrollTop: $(target).offset().top - 100
    },
    1000
  );
}

class LandPage extends Component {
  componentDidMount() {
    $('.navTo').click(scroll);
  }

  componentDidUpdate() {
    $('html, body').animate(
      {
        scrollTop: 0
      },
      0
    );
    $('.navTo').click(scroll);
  }

  render() {
    return (
      <div className="row">
        <div className="nine columns">
          <div className="myDesc">
            <h2>
              Ritz (Yufeng) ✺ is a full stack product designer with 6 years of
              design experience.
            </h2>

            <p>
              <p />✰ Currently designing at{' '}
              <a
                className="link underline"
                href="https://taichi.network/"
                target="_blank"
              >
                Hashing
              </a>
              . Previously studied MS in HCI at{' '}
              <a
                className="link underline"
                href="https://mshci.gatech.edu/"
                target="_blank"
              >
                Georgia Tech
              </a>{' '}
              and worked at{' '}
              <a
                className="link underline"
                href="https://www.assurant.com/"
                target="_blank"
              >
                Assurant
              </a>
              ,{' '}
              <a
                className="link underline"
                href="https://www.apphatchery.org/"
                target="_blank"
              >
                AppHatchery
              </a>{' '}
              and{' '}
              <a
                className="link underline"
                href="https://scaledinference.com/"
                target="_blank"
              >
                Scaled Inference
              </a>
              . ✰ Specialized in enterprise software design and inclusive
              design. ✰ Passionate about transforming complex problems into
              human-centered solutions and excelling in fast-paced environments.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default LandPage;



// WEBPACK FOOTER //
// ./src/Modules/Home/LandPage.js